// BOT-1697: reads the plan feature verdict Rails puts on the logged-in user.
// No payload, a null payload or an empty map means an older Rails deploy. Most
// features fail open, but the ones that used to be capabilities fall back to the
// capability so a merchant never gains what they did not have before.

export const LEGACY_CAPABILITY_FEATURES = ['invoicing', 'resellers', 'subscriptions']

export const lockedPath = key => `/locked/${key}`

export function resolveEntitlements(user) {
  const raw = user?.attributes?.entitlements
  const features = raw && raw.features && typeof raw.features === 'object' ? raw.features : {}
  const known = Object.keys(features).length > 0
  return { known, features, locked: (raw && raw.locked) || {} }
}

const valueOf = (user, key) => {
  const { known, features } = resolveEntitlements(user)
  if (!known || !(key in features)) return undefined
  return features[key]
}

const legacyCapabilityOn = (user, key) => (user?.attributes?.capabilities ?? []).includes(key)

// A switch is on when true; a limit is on unless it is 0; unknown is on, except
// the legacy capability features, which follow the capability until Rails sends a payload.
export function featureOn(user, key) {
  if (!resolveEntitlements(user).known && LEGACY_CAPABILITY_FEATURES.includes(key)) return legacyCapabilityOn(user, key)
  const value = valueOf(user, key)
  if (value === undefined || value === null) return true
  if (typeof value === 'number') return value > 0
  return value === true
}

// Integer cap, or null when unlimited, a switch, or unknown.
export function featureLimit(user, key) {
  const value = valueOf(user, key)
  return typeof value === 'number' ? value : null
}

export function featureLocked(user, key) {
  return resolveEntitlements(user).locked[key] || null
}

export function featureState(user, key) {
  if (featureOn(user, key)) return 'on'
  return featureLocked(user, key) ? 'locked' : 'hidden'
}
